/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import createAsyncMutation from '../../utils/generators'

// Initial state
const state = {
  status: null,
  error: null,
  count: 0,
  page: 1,
  calibrations: []
}

// Getters
const getters = {
  calibrationsLoading: state => state.status === 'loading',
  calibrationsStatus: state => state.status,
  calibrationsError: state => state.error,
  calibrations: state => state.calibrations,
  calibrationCount: state => state.count,
  calibrationPage: state => state.page
}
// Mutations
const mutations = {
  GET_CALIBRATIONS_PENDING(state) {
    state.status = 'loading'
  },
  GET_CALIBRATIONS_SUCCESS(state, { data, count }) {
    state.status = 'success'
    state.count = count
    state.calibrations = data
  },
  GET_CALIBRATIONS_FAILURE(state) {
    state.status = 'error'
  },
  PUT_CALIBRATION_PENDING(state) {
    state.status = 'loading'
  },
  PUT_CALIBRATION_SUCCESS(state) {
    state.status = 'success'
  },
  PUT_CALIBRATION_FAILURE(state, error) {
    state.status = 'error'
    if (error.status === 403) {
      state.error = error.data.detail
    } else {
      const keys = Object.keys(error.data)
      state.error = `${keys[0]}: ${error.data[keys[0]][0]}` // Show 1st error for 1st key
    }
  },
  POST_CALIBRATION_PENDING(state) {
    state.status = 'loading'
  },
  POST_CALIBRATION_SUCCESS(state) {
    state.status = 'success'
  },
  POST_CALIBRATION_FAILURE(state, error) {
    state.status = 'error'
    if (error.status === 403) {
      state.error = error.data.detail
    } else {
      const keys = Object.keys(error.data)
      state.error = `${keys[0]}: ${error.data[keys[0]][0]}` // Show 1st error for 1st key
    }
  },
  SET_CALIBRATION_PAGE(state, page) {
    state.page = page
  }
}

// Actions
const actions = {
  getCalibrations: ({ dispatch, rootState }, params) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.calibrations}/`
    const options = { params }
    const mutationTypes = createAsyncMutation('GET_CALIBRATIONS')
    return dispatch('fetch', { url, mutationTypes, options }).then(calibrations => calibrations)
  },
  saveCalibration: ({ dispatch, rootState }, data) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.calibrations}/${data.id}/`
    const mutationTypes = createAsyncMutation('PUT_CALIBRATION')
    return dispatch('put', { url, mutationTypes, data }).then(calibration => calibration)
  },
  createCalibration: ({ dispatch, rootState }, data) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.calibrations}/`
    const mutationTypes = createAsyncMutation('POST_CALIBRATION')
    return dispatch('post', { url, mutationTypes, data }).then(calibration => calibration)
  },
  setCalibrationPage: ({ commit }, { page }) => {
    commit('SET_CALIBRATION_PAGE', page)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrations.js